import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function PatientBottomNav() {
  const { pathname } = useLocation();
  const authData = useSelector((state) => state.auth);
  const userId = authData.user?.id;

  const navItems = [
    {
      to: "/patient-dashboard",
      label: "Home",
      icon: "icon-Layout-4-blocks",
      isActive: (path) => path === "/patient-dashboard",
    },
    {
      to: `/add-bp-records/${userId}/?color=red`,
      label: "My BP",
      icon: "icon-Compiling",
      isActive: (path) => path.startsWith("/add-bp-records"),
    },
    {
      to: "/family-members",
      label: "Family",
      icon: "icon-Barcode-read",
      isActive: (path) =>
        path === "/family-members" || path.startsWith("/add-family-members"),
    },
    {
      to: "/instructions",
      label: "Protocol",
      icon: "icon-Diagnostics",
      isActive: (path) => path === "/instructions",
    },
  ];

  return (
    <nav className="admin-bottom-nav" aria-label="Patient navigation">
      {navItems.map((item) => {
        const active = item.isActive(pathname);

        return (
          <Link
            key={item.to}
            to={item.to}
            className={`admin-bottom-nav__item${active ? " is-active" : ""}`}
            aria-current={active ? "page" : undefined}
            onClick={() => document.body.classList.remove("sidebar-open")}
          >
            <i className={item.icon}>
              <span className="path1"></span>
              <span className="path2"></span>
              {item.icon === "icon-Diagnostics" ? (
                <span className="path3"></span>
              ) : null}
            </i>
            <span className="admin-bottom-nav__label">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
